/**
 * A collection of translations to use when i18nProvider is unavailable or
 * when the consumer doesn't specify necessary translation keys, e.g. , close.
 */
export const fallback = {
    'de-DE': {
        local: {
            back: 'Zurück',
            clearSearch: 'Suche löschen',
            close: 'Schließen',
            dismiss: 'Ablehnen',
            options: 'Optionen',
            remove: 'Entfernen',
            toggle: 'Ein-/ausschalten',
        },
    },
    'en-AU': {
        local: {
            back: 'Back',
            clearSearch: 'Clear search',
            close: 'Close',
            dismiss: 'Dismiss',
            options: 'Options',
            remove: 'Remove',
            toggle: 'Toggle',
        },
    },
    'en-GB': {
        local: {
            back: 'Back',
            clearSearch: 'Clear Search',
            close: 'Close',
            dismiss: 'Dismiss',
            options: 'Options',
            remove: 'Remove',
            toggle: 'Toggle',
        },
    },
    'en-US': {
        local: {
            back: 'Back',
            clearSearch: 'Clear search',
            close: 'Close',
            dismiss: 'Dismiss',
            options: 'Options',
            remove: 'Remove',
            toggle: 'Toggle',
        },
    },
    'es-ES': {
        local: {
            back: 'Atrás',
            clearSearch: 'Borrar búsqueda',
            close: 'Cerrar',
            dismiss: 'Descartar',
            options: 'Opciones',
            remove: 'Eliminar',
            toggle: 'Toggle',
        },
    },
    'fr-FR': {
        local: {
            back: 'Précédent',
            clearSearch: 'Effacer la recherche',
            close: 'Fermer',
            dismiss: 'Rejeter',
            options: 'Options',
            remove: 'Supprimer',
            toggle: 'Toggle',
        },
    },
    'fi-FI': {
        local: {
            back: 'Takaisin',
            clearSearch: 'Tyhjennä haku',
            dismiss: 'Ohita',
            close: 'Sulje',
            remove: 'Poista',
            toggle: 'Toggle',
            options: 'Asetukset',
        },
    },
    'ja-JP': {
        local: {
            back: '戻る',
            clearSearch: '検索のクリア',
            dismiss: '却下する',
            close: '閉じる',
            remove: '削除',
            toggle: 'トグル',
            options: 'オプション',
        },
    },
    'sv-SE': {
        local: {
            back: 'Bakåt',
            clearSearch: 'Rensa sökning',
            close: 'Stänga',
            dismiss: 'Avvisa',
            options: 'Alternativ',
            remove: 'Ta bort',
            toggle: 'Växla',
        },
    },
};
//# sourceMappingURL=fallback.js.map